import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { SelectType } from '../types';
import { SelectProps } from '@mui/material';

interface IMultiSelectChip extends SelectProps {
  value: SelectType[] | number[] | string[],
  onSelectOption: (data: SelectType[]) => void,
  label: string,
  multiple?: boolean,
  selectOptions: Array<SelectType>
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultiSelectChip (props: IMultiSelectChip) {

  const defaultProps = {
    multiple: true
  };

  props = { ...defaultProps, ...props };

  const { selectOptions, label, value, onSelectOption, onChange, readOnly, multiple, ...selectProps } = props;

  //const valueIds = value.map((x: SelectType)=>x.id);

  const optionsIdMap: any = {};
  selectOptions.map((x: SelectType)=>optionsIdMap[x.id] = { id: x.id, name: x.name });

  const changeHandler = (event: any) => {

    if (props.multiple === undefined || props.multiple) {
      const values = event.target.value as Array<number>;
      onSelectOption(values.map(x=>optionsIdMap[x]));
    } else {
      onSelectOption([optionsIdMap[event.target.value]]);
    }

  };

  let selectValue: Array<number|string>;
  if (value && value.length > 0 && typeof value[0] === 'object') {
    const selectTypeValues = value as unknown;
    selectValue = (selectTypeValues as SelectType[]).map((x: SelectType ) => x.id);

  } else {
    selectValue = value as string[] | number[];
  }

  return <div>
    <FormControl sx={{ m: 1, width: 230 }} size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        size="small"
        sx={{ maxWidth: '230px' }}
        labelId="demo-multiple-chip-label"
        multiple={multiple}
        value={selectValue}
        onChange={changeHandler}
        IconComponent={readOnly ? ()=>(<div />) : undefined}
        input={<OutlinedInput id="select-multiple-chip" label={label} />}
        renderValue={(selected: unknown) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {(selected as number[]).map((x: number, i: number) => {
              if (typeof optionsIdMap[x] === 'undefined') {
                return <Chip size="small" key={i} label={'id_' + x} />;
              } else {
                return <Chip size="small" key={i} label={optionsIdMap[x].name} />;
              }
              
            })}
          </Box>
        )}
        MenuProps={MenuProps}
        {...selectProps}
      >
        {selectOptions.map((x: SelectType, i: number) => (
          <MenuItem
            dense={true}
            key={i}
            value={x.id}
          >
            {x.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </div>;
}